import React, {Component, PropTypes} from 'react';
import {Button} from 'react-bootstrap';
import styled from 'styled-components';

import CurrencyType from '../../../../constants/CurrencyType';
import NumberFormat from 'react-number-format';
import RefundModal from '../../RefundModal/RefundModal';
import PaymentStatus from '../../../../constants/PaymentStatus';
import moment from 'moment';
import {
  deletePayment
} from '../../../../api/api';
import RefundReasonType from "../../../../constants/RefundReasonType";

const Container = styled.div`
  display: flex;
  min-height: 60px;
  text-align: justify;
  padding: 0;
  align-items: center;

  & div:first-child {
    color: black;
  }
  
  &:not(:last-child) {
    border-bottom: 1px solid #d8d8d8;
  }
`;

const PaymentTime = styled.div`
  width: 202px;
`;

const Amount = styled.div`
  width: 120px;
`;

const PaymentState = styled.div`
  font-size: 16px;
  color: ${props => {
  switch (props.paymentStatus) {
    case PaymentStatus.PAID:
    case PaymentStatus.BATCH_PAID:
    case PaymentStatus.MANUAL_PAID:
    case PaymentStatus.STRIPE_PAID:
      return 'black';
    case PaymentStatus.SCHEDULED:
      return '#42ae03';
    case PaymentStatus.REFUNDED:
      return '#717171';
    case PaymentStatus.FAILED:
    default:
      return '#f70e30';
  }
}};
`;

const RefundButton = styled(Button)`
  font-size: 12px;
  color: #717171;
  border-radius: 3px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
  border: solid 1px #d8d8d8;
  padding: 6px 8px;
  margin-left: auto;
  text-transform: capitalize;
`;

const DeleteButton = styled(Button)`
  font-size: 12px;
  color: #717171;
  border-radius: 3px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
  border: solid 1px #d8d8d8;
  padding: 6px 8px;
  margin-left: auto;
  text-transform: capitalize;
`;

class PaymentHistoryItem extends Component {
  constructor(props) {
    super(props);

    const paymentStatus = props.paymentStatus;
    const scientificNotation = Math.pow(10, props.currencyType.decimalScale * -1);
    const floatAmount = (props.amount * scientificNotation).toFixed(2);
    let description;

    if(paymentStatus === PaymentStatus.REFUNDED)
    {
      let refundReason = props.description ? RefundReasonType.enumValueOf(props.description.toUpperCase()).title : null;

      description =  PaymentStatus.REFUNDED.name + (refundReason ? '(' + refundReason + ')' : '')
    }else{
      description =  props.description ? props.description : (paymentStatus ? paymentStatus.name : '')
    }


    this.state = {
      showRefundModal: false,
      scientificNotation,
      paymentStatus,
      description,
      floatAmount,
    };
  }

  refundClickHandler = () => {
    this.setState({
      showRefundModal: true,
    });
  };

  deleteClickHandler = () => {
     deletePayment(this.props.paymentId, (err, result) => {
        if (err) {
          Messenger().post({
            type: 'error',
            message: `${err.message} (${err.statusCode})`,
            showCloseButton: true,
          });
        } else {
          if (result.statusCode === '0' || result.statusCode === 0) {
            this.props.paymentStatusChanged(this.props.paymentId)
            Messenger().post({
              type: 'success',
              message: 'Delete successfully.',
              showCloseButton: true,
            });
          } else {
            Messenger().post({
              type: 'error',
              message: `delete failed.`,
              showCloseButton: true,
            });
          }
        }
      });
  }


  closeRefundModal = (success) => {
    if(success)
    {
      this.props.paymentStatusChanged(this.props.paymentId)
    }

    this.setState({
      showRefundModal : false,
      paymentStatus   :  PaymentStatus.REFUNDED
    });
  };
  getCreatedDateTime(timestamp) {
    return moment(timestamp).format('YYYY-MM-DD hh:mm:ss');
  }

  render() {
    return (
        <Container>
            <PaymentTime> { this.props.paymentTime ?  this.getCreatedDateTime(this.props.paymentTime) : this.getCreatedDateTime(this.props.expectedPaymentDate)}</PaymentTime>
          {
            this.props.currency ? (
                <NumberFormat
                    displayType="text"
                    thousandSeparator
                    prefix={`${this.props.currency} `}
                    decimalScale={this.props.decimalScale}
                    fixedDecimalScale
                    value={this.state.floatAmount}
                    renderText={value => <Amount>{value}</Amount>}
                />
            ) : null
          }
          <PaymentState paymentStatus={this.state.paymentStatus}>
            {
              this.state.description
            }
          </PaymentState>
          {
            this.state.paymentStatus === PaymentStatus.PAID
            || this.state.paymentStatus === PaymentStatus.MANUAL_PAID
            || this.state.paymentStatus === PaymentStatus.BATCH_PAID
            ? (
                <RefundButton onClick={this.refundClickHandler}>
                  Refund
                </RefundButton>
            ) : null
          }
          {
            this.state.paymentStatus === PaymentStatus.STRIPE_PAID
                ? (
                    <DeleteButton onClick={this.deleteClickHandler}>
                      Delete
                    </DeleteButton>
                ) : null
          }
          <RefundModal
              showModal={this.state.showRefundModal}
              closeModal={this.closeRefundModal}
              paymentId={this.props.paymentId}
              amount={this.props.amount}
              currency={this.props.currency}
              currencyType={this.props.currencyType}
          />
        </Container>
    );
  }
}

PaymentHistoryItem.propTypes = {
  createdDate: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
  currencyType: PropTypes.instanceOf(CurrencyType).isRequired,
  amount: PropTypes.number.isRequired,
  paymentId: PropTypes.number.isRequired,
  failedCount: PropTypes.number,
  paymentTime: PropTypes.number,
  expectedPaymentDate: PropTypes.number,
  expectedPaymentMonth: PropTypes.number,
  paymentStatus: PropTypes.instanceOf(PaymentStatus).isRequired,
  paymentStatusChanged: PropTypes.func.isRequired
};

export default PaymentHistoryItem;



// WEBPACK FOOTER //
// ./src/routes/patient/PaymentHistory/PaymentHistoryItem/PaymentHistoryItem.js